import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

export type ReportScheduleRecipientTypeModel = 'user' | 'team' | 'role' | 'email';

/**
 * PD-17398 — who a scheduled report goes to: a person, a team (with its
 * sub-teams by default), a role (its members at send time) or an email
 * address. Teams and roles are resolved when it sends, so a new team member
 * gets the next one.
 */
@Index('idx_report_schedule_recipient_schedule', ['fkReportScheduleId'])
@Entity('report_schedule_recipient')
export class ReportScheduleRecipientEntity extends BaseEntity {
	@Column('int', { name: 'fk_report_schedule__id', unsigned: true })
	public fkReportScheduleId!: number;

	@Column('varchar', { name: 'recipientType', length: 10 })
	public recipientType!: ReportScheduleRecipientTypeModel;

	/** Tenant `user._id` for a person. */
	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public fkUserId!: number | null;

	@Column('int', { name: 'fk_team__id', unsigned: true, nullable: true })
	public fkTeamId!: number | null;

	/**
	 * 1 or 0. Typed as the number the tinyint reads back (PD-17518), so every
	 * read has to say what it means: includesSubTeams().
	 */
	@Column('tinyint', { name: 'includeSubTeams', width: 1, default: 1 })
	public includeSubTeams!: number;

	/** `_rbac_role._id` for a role. */
	@Column('int', { name: 'fk__rbac_role__id', unsigned: true, nullable: true })
	public fkRbacRoleId!: number | null;

	@Column('varchar', { name: 'email', length: 255, nullable: true })
	public email!: string | null;
}
